import React from 'react';
import classNames from 'classnames';

import {percent} from 'js/common/string_helper';

const femaleImg = require('images/admin/campaign_wrap_up/icons/icon-female.png');
const maleImg = require('images/admin/campaign_wrap_up/icons/icon-male.png');

function GenderAnalytics(props) {
    const {femalePercentage, malePercentage, borders, renderForPdf, getAssetPath} = props;

    const genderAnalyticsClasses = classNames('gender-analytics', {
        'container-border-top': borders.top,
        'container-border-right': borders.right,
        'container-border-bottom': borders.bottom,
        'container-border-left': borders.left
    });

    return (
        <div className={genderAnalyticsClasses}>
            <div className="gender-header">GENDER</div>
            <div className="gender-percentages">
                <div className="female-percentage">
                    <img src={getAssetPath(femaleImg)} />
                    <div className="percentage-text">{percent(femalePercentage, 0)} FEMALE</div>
                </div>
                <div className="male-percentage">
                    <img src={getAssetPath(maleImg)} />
                    <div className="percentage-text">{percent(malePercentage, 0)} MALE</div>
                </div>
            </div>

            {/*STYLES*/}

            <style>{`
            .gender-analytics {
            width: 50%;
            }

            .gender-header {
            font-size: 20px;
            font-weight: bold;
            color: #000;
            padding-bottom: 20px;
            }

            .female-percentage {
            padding: 0px 50px;
            }

            .male-percentage {
            padding: 0px 50px;
            }

            .percentage-text {
            font-size: 20px;
            font-weight: bold;
            color: #4ed2c3;
            padding-top: 20px;
            }

            .container-border-top {
            border-top: 1px solid #d4d4d4;
            }

            .container-border-right {
            border-right: 1px solid #d4d4d4;
            }

            .container-border-bottom {
            border-bottom: 1px solid #d4d4d4;
            }

            .container-border-left {
            border-left: 1px solid #d4d4d4;
            }
            `}</style>

            {/*STYLE FOR WEB*/}
            {!renderForPdf ? (
                <style>{`
                .gender-analytics {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                }

                .gender-percentages {
                display: flex;
                justify-content: center;
                align-items: center;
                flex-wrap: wrap;
                }

                .female-percentage {
                display: flex;
                flex-direction: column;
                align-items: center;
                }

                .male-percentage {
                display: flex;
                flex-direction: column;
                align-items: center;
                }
                `}</style>
            ) : null}

            {/*STYLE FOR PDF*/}
            {renderForPdf ? (
                <style>{`
                .gender-analytics {
                display: inline-block;
                vertical-align: top;
                width: 49%;
                }

                .gender-header {
                text-align: center;
                }

                .gender-percentages {
                text-align: center;
                }

                .female-percentage {
                display: inline-block;
                vertical-align: top;
                }

                .male-percentage {
                display: inline-block;
                vertical-align: top;
                }
                `}</style>
            ) : null}
        </div>
    );
}

GenderAnalytics.propTypes = {};

export default GenderAnalytics;



// WEBPACK FOOTER //
// ./campaign_analytics/campaign_wrap_up/analytics_shared/gender_analytics.js